module.exports = __webpack_public_path__ + "img/1538448849.3f83548b.jpg";